<template>
  <v-dialog :value="value" @input="onInput" width="600" height="600">
    <v-card class="pa-0 ma-0">
      <cropper
        v-if="image"
        class="cropper"
        ref="cropper"
        :src="image"
        :stencil-props="{
          aspectRatio: asp_ratio ? asp_ratio : 1 / 1,
        }"
        :stencil-component="circle ? 'circle-stencil' : 'rectangle-stencil'"
      >
      </cropper>
      <v-card-actions class="justify-space-between">
        <div>
          <v-btn outlined icon class="mr-3" @click="rotate(-90)"
            ><v-icon>mdi-rotate-left</v-icon></v-btn
          >
          <v-btn outlined icon class="mr-3" @click="rotate(90)"
            ><v-icon>mdi-rotate-right</v-icon></v-btn
          >
          <v-btn outlined icon class="mr-3" @click="flip(true, false)"
            ><v-icon>mdi-flip-horizontal</v-icon></v-btn
          >
          <v-btn outlined icon class="mr-3" @click="flip(false, true)"
            ><v-icon>mdi-flip-vertical</v-icon></v-btn
          >
        </div>
        <v-spacer></v-spacer>
        <v-btn outlined @click="onClickCropImageSaveHandler">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
  components: { Cropper },

  props: {
    value: {
      type: Boolean,
    },
    image: {
      default: null,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    asp_ratio: {
      default: null,
      type: Number,
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    flip(x, y) {
      if (this.$refs.cropper.imageTransforms.rotate % 180 !== 0) {
        this.$refs.cropper.flip(!x, !y);
      } else {
        this.$refs.cropper.flip(x, y);
      }
    },
    rotate(angle) {
      this.$refs.cropper.rotate(angle);
    },
    onClickCropImageSaveHandler() {
      const { canvas } = this.$refs.cropper.getResult();
      this.$emit("onCrop", canvas);
      this.$emit("input", false);
      this.$refs.cropper.reset();
    },
  },
};
</script>
<style scoped>
.cropper {
  height: 500px;
}
</style>
